'use client'
import { Common, Messages, RingBuilder } from '@/config/NextImport'
import { AppState } from '@/lib/store'
import dynamic from 'next/dynamic'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const Setting = dynamic(() => import('./Setting'))
const Diamond = dynamic(() => import('./Diamond'))
const Review = dynamic(() => import('./Review'))
const ShoppingProgressSkeleton = dynamic(() => import('./ShoppingProgressSkeleton'))

const ShoppingProgress = ({ category, isDetailsPage }: any) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { settingOptions } = useSelector((state: AppState) => state.settings)
  const [Steps, setSteps] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)
  const { isRingBuilderReady } = useSelector((state: AppState) => state.ringBuilder)

  useEffect(() => {
    if (typeof window === 'undefined') return
    getSteps()
  }, [category?.is_diamond_category, pathname, isRingBuilderReady])

  const getSteps = async () => {
    setLoading(true)
    let storageSteps: any = RingBuilder.getRingBuilder()
    let IsGemstone = false
    if (pathname.toLowerCase() === '/complete-jewel') {
      openReviewStep()
      storageSteps = RingBuilder.getRingBuilder()
      setSteps(storageSteps)
    } else {
      if (storageSteps == null) {
        RingBuilder.setDefaultRingBuilder(
          pathname,
          category?.is_diamond_category !== undefined ? category?.is_diamond_category : 0
        )
      } else {
        if (category?.is_diamond_category === 1) {
          IsGemstone = category?.is_gemstone_category
        } else
          IsGemstone = storageSteps.filter((item: any) => item.step === 'diamond')[0].IsGemstone
      }
      RingBuilder.setRingBuilderFromURL(pathname, category?.is_diamond_category, IsGemstone)
      // if (!isDetailsPage) {
      // }

      storageSteps = RingBuilder.getRingBuilder()
      storageSteps.map((item: any) => {
        if (item.step === 'diamond') {
          if (category?.is_gemstone_category || item.IsGemstone) {
            item.IsGemstone = true
          } else {
            item.IsGemstone = false
          }
          // //reset diamond/gemstone step
          if (
            category?.is_diamond_category &&
            category?.is_gemstone_category !== null &&
            category?.is_gemstone_category !== item.product?.is_gemstone
          ) {
            item.product = null
            item.IsCompleted = false
            if (!category?.is_gemstone_category) item.IsGemstone = false
          }
        }
        return true
      })
      RingBuilder.setRingBuilder(storageSteps)
    }
    setSteps(storageSteps)
    setLoading(false)
  }

  const openReviewStep = () => {
    const sParams = searchParams.get('s')
    const diamondParam = searchParams.get('j')
    if (diamondParam === undefined || sParams === undefined) {
      return
    }
    let isGemstone = false
    // if the diamond param contains gemstone then set gemstone flag to true
    if (sessionStorage.getItem(Messages.IsGemstone) === 'true') {
      isGemstone = true
      sessionStorage.removeItem(Messages.IsGemstone)
    }
    if (RingBuilder.getRingBuilder() == null) {
      RingBuilder.setDefaultRingBuilder(pathname, 0, isGemstone)
      const storageSteps: any = RingBuilder.getRingBuilder()

      storageSteps.map((innerStep: any) => {
        if (innerStep.step === 'review') {
          innerStep.IsActive = true
          innerStep.IsChange = false
          innerStep.IsView = true
        } else {
          innerStep.IsCompleted = true
          innerStep.IsActive = false
        }
        return true
      })
      RingBuilder.setRingBuilder(storageSteps)
    }
  }

  const onStepClick = (e: any, tabURL: string, stepno: number) => {
    e.preventDefault()
    const storageSteps: any = RingBuilder.getRingBuilder()
    const activeStep: any = storageSteps.filter((x: any) => x.IsActive === true)[0].stepno
    if (activeStep === stepno) {
      const currentURL = pathname + (searchParams?.toString() ? `?${searchParams}` : '')
      router.push(currentURL)
      return
    }
    if (stepno === 2) {
      const firstStep = storageSteps.filter((x: any) => x.stepno === 1)[0]
      if (firstStep.selected_productid !== undefined) {
        if (tabURL !== '') {
          router.push(tabURL)
        } else {
          if (firstStep.step === 'diamond') {
            const defaultSettingURL = settingOptions.filter(
              (item: any) => item.hj_key === 'ENGAGEMENT_RING_ALL_SETTING_URL'
            )[0].hj_value
            router.push(defaultSettingURL)
          } else {
            const isGemstone = storageSteps.filter((x: any) => x.step === 'diamond')[0].IsGemstone
            let defaultDiamondURL = settingOptions.filter(
              (item: any) => item.hj_key === 'EARTH_DIAMOND_URL'
            )[0].hj_value
            if (isGemstone) defaultDiamondURL = Messages.Gemstones
            router.push(defaultDiamondURL)
          }
        }
      } else {
        if (firstStep.step === 'diamond') {
          const defaultSettingURL = settingOptions.filter(
            (item: any) => item.hj_key === 'ENGAGEMENT_RING_ALL_SETTING_URL'
          )[0].hj_value
          RingBuilder.setSettingBuilder(defaultSettingURL, firstStep?.IsGemstone)
          setSteps(RingBuilder.getRingBuilder())
          router.push(defaultSettingURL)
        } else {
          const isGemstone = storageSteps.filter((x: any) => x.step === 'diamond')[0].IsGemstone
          let defaultDiamondURL = settingOptions.filter(
            (item: any) => item.hj_key === 'EARTH_DIAMOND_URL'
          )[0].hj_value
          if (isGemstone) defaultDiamondURL = Messages.Gemstones
          RingBuilder.setDiamondBuilder(defaultDiamondURL, isGemstone)
          router.push(defaultDiamondURL)
        }
      }
    } else {
      let listingURL = ''
      storageSteps.map((item: any) => {
        if (item.stepno === stepno) {
          item.IsActive = true
          item.IsChange = true
          listingURL = item.url
        } else {
          item.IsActive = false
          item.IsView = false
          item.IsChange = false
        }
        return true
      })
      RingBuilder.setRingBuilder(storageSteps)
      setSteps(storageSteps)
      router.push(listingURL)
    }
  }
  const onViewStep = (stepno: number, IsView: boolean, url: string) => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    storageSteps.map((item: any) => {
      if (item.stepno === stepno) {
        item.IsActive = true
        if (IsView) {
          item.IsView = true
          item.IsChange = false
        } else {
          item.IsView = false
          item.IsChange = true
        }
      } else {
        item.IsActive = false
        item.IsView = false
        item.IsChange = false
      }
      return true
    })
    RingBuilder.setRingBuilder(storageSteps)
    router.push(url)
  }

  const swapSteps = (Steps: any) => {
    const updatedSteps = []
    const step1 = Steps.filter((x: any) => x.stepno === 2)
    const step2 = Steps.filter((x: any) => x.stepno === 1)
    const step3 = Steps.filter((x: any) => x.stepno === 3)
    updatedSteps.push(step1[0])
    updatedSteps.push(step2[0])
    updatedSteps.push(step3[0])
    updatedSteps[0].stepno = 1
    updatedSteps[1].stepno = 2
    updatedSteps[0].class = 'first-step'
    updatedSteps[1].class = 'second-step'
    return updatedSteps
  }

  const onChangeStep = (stepno: number, IsView: boolean, url: string) => {
    let storageSteps: any = RingBuilder.getRingBuilder()
    if (stepno === 1) {
      if (
        storageSteps[0].product.selected_productid !== undefined &&
        storageSteps[1].product.selected_productid !== undefined
      ) {
        storageSteps = swapSteps(storageSteps)
      }
    }
    storageSteps.map((item: any) => {
      if (item.stepno === stepno) {
        item.IsActive = true
        if (IsView) {
          item.IsView = true
          item.IsChange = false
        } else {
          item.IsView = false
          item.IsChange = true
        }
      } else {
        item.IsActive = false
        item.IsView = false
        item.IsChange = false
      }
      return true
    })
    RingBuilder.setRingBuilder(storageSteps)
    router.push(Common.getSanitizedUrl(url))
  }

  if (category?.is_mto_category) return
  return (
    <>
      {loading ? (
        <ShoppingProgressSkeleton />
      ) : (
        <>
          {!Common.isNullorEmpty(Steps) && (
            <div className="container">
              <div className="step-bar-section">
                <div className="row step-bar-section-row">
                  {Steps.map((item: any) => {
                    switch (item.step) {
                      case 'setting':
                        return (
                          <Setting
                            item={item}
                            key={item.stepno}
                            onStepClick={onStepClick}
                            onViewStep={onViewStep}
                            onChangeStep={onChangeStep}
                          />
                        )
                      case 'diamond':
                        return (
                          <Diamond
                            item={item}
                            key={item.stepno}
                            onStepClick={onStepClick}
                            onViewStep={onViewStep}
                            onChangeStep={onChangeStep}
                          />
                        )
                      default:
                        return (
                          <Review
                            item={item}
                            key={item.stepno}
                            onStepClick={onStepClick}
                            onViewStep={onViewStep}
                            onChangeStep={onChangeStep}
                            steps={Steps}
                          />
                        )
                    }
                  })}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default ShoppingProgress
